import {addStyle, getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {className, style, size, color} = self.get();

const classNameObj = {
    "k-icon": true,
    [className]: className,
};
const _style = {};
if (/^\d+$/.test(size)) {
    _style.fontSize = size + 'px'; 
} else if (size !== 'default') {
    classNameObj[`k-${size}`] = true;
}
if (self.colors.indexOf(color) > -1) {
    classNameObj[`k-color-${color}`] = color !== 'default';
} else if (color) {
    _style.color = color;
}

    return h('i', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'style': function() {try {return (addStyle(style, _style) )} catch(e) {_e(e)}}.call($this)
    }, null, _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}